<template>
  <v-main class="m-0" :class="{ 'pa-0': $vuetify.breakpoint.smAndUp }">
    <v-app-bar class="color-app-bar" app dark>
      <v-toolbar-title> 
        <b><b>JIJE</b></b> UNL
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        class="ma-2"
        outlined
        color="white"
        small
        to="/login"
      >
        Iniciar Sesión
      </v-btn>
    </v-app-bar>
    
    <body class="body-index d-flex align-center justify-center">
      <v-row>

        <v-col cols="12" xl="6" md="6" sm="12"
          v-if="$vuetify.breakpoint.smAndUp">
          <v-row>
            <v-col
              cols="12" class="mt-8 d-flex justify-center">
              <v-img 
                max-width="460px"
                max-height="460px"
                contain
                :src="require('@/assets/img/index_jije.png')">
              </v-img>
            </v-col>
          </v-row>
        </v-col>

        <v-col 
          cols="12" 
          xl="6" 
          md="6" 
          sm="12" 
          class="d-flex align-center justify-center" >

          <v-card max-width="380px" class="ma-2" color="#CEE6EA">
          
            <template v-if="option_selected=='index'">
              <v-card-text min-height="300px">
                <p class="text-h6 text-center text--primary">
                  JORNADAS INTERNACIONALES DE JOVENES EMPRENDEDORES
                </p>
                <p class="text-center">
                  MATCH SIN LÍMITES
                </p>
                <p class="text-center pl-8 pr-8">
                  Adquirí competencias emprendedoras, conoce nuevas estrategias,
                  intercambiá ideas y viví esta experiencia internacional.
                </p>
                <p class="text-center">
                  ¡Inscribite y participá!
                </p>
              </v-card-text>
              
              <v-card-actions>
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      block
                      class="mt-2"
                      x-large
                      dark
                      color="#FF41BD"
                      :to="{ name: 'RegisterParticipant' , params:{ slug: public_access.slug}}"
                    >
                      <b>Regístrate</b>
                    </v-btn>  


                    <v-btn
                      block
                      class="mt-2"
                      x-large
                      v-for="convocation in convocations"
                      v-bind:key="convocation.id"
                      color="primary"
                      @click="selectOption('postulate_project', convocation.slug)"
                    >
                    <b>Postular un proyecto</b>
                    </v-btn>
                    
                    <v-btn
                      block
                      class="mt-2"
                      x-large
                      color="#17FF39"
                      @click="selectOption('login',null)"
                    >
                      <b>Iniciá Sesión</b>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </template>
            
            <PostulateProject 
              :source="nada" 
              :edition="edition_selected"
              v-if="option_selected=='postulate_project'" />

            <RegisterParticipant
              :edition="edition_selected"
              v-if="option_selected=='register_participant'" />

            <LoginComponent v-if="option_selected=='login'" />

            <v-card-actions :class="{ 'pa-3': $vuetify.breakpoint.smAndUp }">
              <v-row>
                <v-col cols="12">
                  <v-btn 
                    color="info" 
                    class="my-auto"
                    block
                    outlined
                    v-if="option_selected!='index'"
                    @click="option_selected = 'index'"
                    small>
                    <v-icon left>mdi-arrow-left</v-icon>
                    Volver
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>  
        </v-col>
        
        <v-col v-if="loading_sponsors && !$vuetify.breakpoint.smAndUp" class="pa-3 mt-8 mb-8">
          <cardFeaturedSponsorsSM :types_sponsors="types_sponsors" />
        </v-col>

      </v-row>
    </body>

    <v-row v-if="loading_sponsors && $vuetify.breakpoint.smAndUp" class="pa-3">
      <cardFeaturedSponsors :types_sponsors="types_sponsors" />
    </v-row>

    <pre>
      {{ public_access }}
    </pre>

  </v-main>
</template>

<script>
import axios from 'axios'
import PostulateProject from '@/components/index/PostulateProject.vue'
import LoginComponent from '@/components/index/LoginComponent.vue'
import RegisterParticipant from '@/components/index/RegisterParticipant.vue'
import cardFeaturedSponsors from '@/components/card/cardFeaturedSponsors.vue'
import cardFeaturedSponsorsSM from '@/components/card/cardFeaturedSponsorsSM.vue'

export default {
  name: 'postulate',
  components: {
    PostulateProject,
    LoginComponent,
    RegisterParticipant,
    cardFeaturedSponsors,
    cardFeaturedSponsorsSM
  },
  data: () => ({
    width_card:380,
    loading:false,
    loading_sponsors:false,
    show_featured_sponsors:false,
    convocations:[],
    public_access:[],
    types_sponsors:[],
    data:[],
    nada:'hola tomas',
    options: ['index', 'register_participant', 'postulate_project'],
    option_selected: 'index',
    edition_selected: null
  }),

  methods: {
    async getConvocations(){
      await axios.get('index').then(response =>{
        this.convocations = response.data.data.convocations
        this.public_access = response.data.data.public_access
        this.data = response.data.data
        if(this.public_access.length>0){
          this.getAllSponsorsEdition()
        }
        this.loading=false
      }).catch(error => {
        console.log(error)
      })
    },

    selectOption(option, edition){
      this.option_selected = option
      this.edition_selected = edition
      if(this.option_selected=='register_participant'){
        this.width_card=380
      }
    },

    async getAllSponsorsEdition(){
        await axios.get('featured-sponsors/1').then(response =>{
          this.types_sponsors = response.data.data.types_sponsors
          this.loading_sponsors = true
        }).catch(error => {
          console.log(error);
        })
      }, 

  },
  created(){
    this.getConvocations()
  }
};
</script>
<style scoped>

.body-index{
  background-image: url("~@/assets/img/background.png");
  background-size: cover;
  min-height: 110vh!important;
}

@media (max-width: 600px) {
  .centered {
    position: absolute;
    top: 60vh;
    left: 50%;
    width: 100vw;
    transform: translate(-50%, -50%);
  }

  .image-landing{
    left: 50%;
    right: 50%;
    margin-top: -50vh;
    margin-bottom: -150px;
    margin-left: -50vw;
    margin-right: -50vw;
    max-width: 100vw;
    position: relative;
    width: 100vw;
    border-bottom: 5px solid #00a1b8;
    filter: brightness(50%);
  }
}
/* Estilos para pantallas medianas (viewport entre 601px y 992px) */
@media (min-width: 601px) {
  .centered {
    position: absolute;
    top: 24rem;
    left: 70%;
    transform: translate(-50%, -14rem);
  }

  .image-landing{
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    max-width: 100vw;
    position: relative;
    width: 100vw;
    border-bottom: 5px solid #00a1b8;
    filter: brightness(50%);
  }
}
</style>